import accounting from 'accounting';
import { FormGroup, HorizontalRule, Table } from 'arag-ui-lib';
import {
  AVERAGE_EXPECTED_PREMIUM,
  CURRENCY,
  CURRENCY_CODE,
  TARGET_COMMISSION,
  TARGET_UNDERWRITER,
} from '../../../helpers/variables';
import '../../../style/stagedStep2.css';
import StagesDescription from './stagesDescription';
const StagedStep2 = (props) => {
  const {
    stagedPremiumsWizard,
    changeStageSubSetting,
    stagedSubSettings,
    agentsList,
    changeStagedPremiumFormData,
    amountColumnsDisplayDataPerStage,
  } = props;
  const underwriterRate = {
    id: TARGET_UNDERWRITER,
    name: 'Underwriter rate',
    commissionPercentage: stagedPremiumsWizard.underwriterRatePercentage,
  };
  const commissionData = [underwriterRate, ...agentsList];
  const averageExpectedPremiumData = [{id: AVERAGE_EXPECTED_PREMIUM, name: 'Value', value: stagedPremiumsWizard.averageExpectedPremium}];

  const averageExpectedPremiumColumns = [
    {
      propertyName: 'AVERAGE_EXPECTED_PREMIUM',
      header: 'Average Expected Premium',
      sortable: false,
      id: 'AVERAGE_EXPECTED_PREMIUM',
      formatter: (v) => {
        return (
          <div className="fixedWidth">
            <FormGroup
              labelSize="col-sm-7"
              inputSize="col-sm-5"
              label={v.name}
              required={true}
              variant="currency"
              inputProps={{
                required: true,
                value: v.value,
                key: v.title,
                name: v.title,
                onChange: (e) => changeStagedPremiumFormData(
                  AVERAGE_EXPECTED_PREMIUM,
                  e.target.value
                ),
                disabledDropdown: true,
                handleOptionSelect: () => {},
                menuOptions: [
                  { sign: `${CURRENCY}`, code: `${CURRENCY_CODE}` },
                ],
                selectedCurrency: {
                  sign: `${CURRENCY}`,
                  code: `${CURRENCY_CODE}`,
                },
              }}
            />
          </div>
        );
      },
    },
  ];
  const ratesColumns = [
    {
      propertyName: 'rates',
      header: 'Rates',
      sortable: false,
      id: 'rates',
      formatter: (v) => {
        return (
          <div className="fixedWidth">
            <FormGroup
              labelSize="col-sm-7"
              inputSize="col-sm-5"
              label={v.name}
              required={true}
              variant="currency"
              inputProps={{
                required: true,
                value: v.commissionPercentage,
                key: v.id,
                name: v.id,
                onChange:
                  v.id == TARGET_UNDERWRITER
                    ? (e) =>
                        changeStagedPremiumFormData(
                          TARGET_UNDERWRITER,
                          e.target.value
                        )
                    : (e) =>
                        changeStageSubSetting(
                          v.id,
                          TARGET_COMMISSION,
                          e.target.value
                        ),
                disabledDropdown: true,
                handleOptionSelect: () => {},
                menuOptions: [{ sign: '%', code: '%' }],
                selectedCurrency: { sign: `%`, code: '%' },
              }}
            />
          </div>
        );
      },
    },
  ];
  const stagesColumns = [
    {
      propertyName: 'stageName',
      header: 'Stage of Policy',
      id: 'stageName',
      formatter: (v) => {
        return <span> {v.stageName}</span>;
      },
    },
    {
      propertyName: 'fields',
      header: 'Amounts',
      id: 'fields',
      formatter: (v) => {
        return amountColumnsDisplayDataPerStage(v).map((c) => {
          return c.isPlain == true ? (
            <div>
              <FormGroup
                labelSize={'col-sm-6'}
                inputSize={'col-sm-6'}
                label={c.title}
                variant={'plain'}
                inputProps={{
                  label: accounting.formatMoney(c.value, `${CURRENCY} `, 2),
                }}
              />
              <HorizontalRule variant="pale" />
            </div>
          ) : (
            <div className="fixedWidth">
              <FormGroup
                labelSize="col-sm-6"
                inputSize="col-sm-6"
                label={c.title}
                required={true}
                variant="currency"
                inputProps={{
                  required: true,
                  value: c.value,
                  key: c.title,
                  name: c.title,
                  onChange: c.onChange,
                  disabledDropdown: true,
                  handleOptionSelect: () => {},
                  menuOptions: [
                    { sign: `${CURRENCY}`, code: `${CURRENCY_CODE}` },
                  ],
                  selectedCurrency: {
                    sign: `${CURRENCY}`,
                    code: `${CURRENCY_CODE}`,
                  },
                }}
              />
              <HorizontalRule variant="pale" />
            </div>
          );
        });
      },
    },
  ];
  return (
    <div>
      <Table
        orderAsc={false}
        striped
        columns={ratesColumns}
        data={commissionData}
      />
      <Table
        orderAsc={false}
        striped
        columns={averageExpectedPremiumColumns}
        data={averageExpectedPremiumData}
      />

      <Table
        orderAsc={false}
        striped
        columns={stagesColumns}
        data={stagedSubSettings != undefined ? stagedSubSettings : []}
      />
      <StagesDescription />
    </div>
  );
};
export default StagedStep2;
